/* TAMITOS theme v8: header, mobile nav, reveals, the playful layer from tamitos.com
   (sky with clouds and soap bubbles, hopping Tamitos), product gallery, variants, qty,
   cart, wishlist, IBAN copy and the 10 % popup. No libraries. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var COLORS = ['#ff8fc4', '#ffcf4d', '#7fc8ff', '#8fe0b0', '#a98bff'];
  var HEART = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 21s-8-5.2-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 5.8-8 11-8 11z"/></svg>';
  var STAR = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12 7-1 11-5 12-12z"/></svg>';

  function burst(x, y, n) {
    if (reduce) return;
    for (var i = 0; i < (n || 10); i++) {
      var e = document.createElement('span');
      e.className = 'fx';
      e.innerHTML = Math.random() < .5 ? HEART : STAR;
      var a = Math.random() * Math.PI * 2, d = 50 + Math.random() * 70;
      e.style.cssText = 'left:' + (x - 10) + 'px;top:' + (y - 10) + 'px;color:' + COLORS[i % 5] + ';font-size:' + (12 + Math.random() * 16) + 'px;--dx:' + Math.cos(a) * d + 'px;--dy:' + (Math.sin(a) * d - 30) + 'px;--r:' + (Math.random() * 180 - 90) + 'deg';
      document.body.appendChild(e);
      setTimeout(function (el) { return function () { el.remove(); }; }(e), 950);
    }
  }

  /* floating header gets a stronger glass once the page moves */
  var head = document.querySelector('[data-head]');
  if (head) {
    var stick = function () { head.classList.toggle('stuck', window.scrollY > 8); };
    stick(); window.addEventListener('scroll', stick, { passive: true });
  }

  /* mobile nav */
  var burger = document.querySelector('.burger');
  var mnav = document.getElementById('mnav');
  if (burger && mnav) {
    var open = false, ico = burger.innerHTML;
    var set = function (v) {
      open = v;
      document.documentElement.classList.toggle('mnav-open', v);
      burger.setAttribute('aria-expanded', String(v));
      burger.innerHTML = v ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' : ico;
      if (v) { mnav.hidden = false; requestAnimationFrame(function () { mnav.classList.add('show'); }); }
      else { mnav.classList.remove('show'); setTimeout(function () { if (!open) mnav.hidden = true; }, 260); }
    };
    burger.addEventListener('click', function () { set(!open); });
    mnav.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('[data-mnav-close]')) set(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) { set(false); burger.focus(); } });
    window.addEventListener('resize', function () { if (open && window.innerWidth > 940) set(false); });
  }

  /* reveal on scroll: siblings come in one after another, and a timeout makes sure
     nothing can stay invisible */
  var rv = [].slice.call(document.querySelectorAll('.rv'));
  if (rv.length) {
    if (reduce || !hasIO) {
      rv.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var p = e.target.parentNode, sib = p ? [].indexOf.call(p.children, e.target) % 4 : 0;
          e.target.style.transitionDelay = (sib * 70) + 'ms';
          e.target.classList.add('in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: .04 });
      rv.forEach(function (el) { io.observe(el); });
      setTimeout(function () { rv.forEach(function (el) { el.classList.add('in'); }); }, 3000);
    }
  }

  /* hero sky: sun, drifting clouds, sparkles and soap bubbles (hero only) */
  var CLOUD = '<svg class="cloud" viewBox="0 0 200 90" aria-hidden="true"><path d="M30 80c-17 0-28-11-28-25s12-25 27-24c3-17 18-29 35-27 11 1 20 7 25 16 6-6 14-9 23-8 16 2 27 15 26 30 15 1 27 11 27 23 0 9-7 15-17 15z"/></svg>';
  [].forEach.call(document.querySelectorAll('[data-sky]'), function (h) {
    if (h.querySelector('.decor')) return;
    var d = document.createElement('div');
    d.className = 'decor'; d.setAttribute('aria-hidden', 'true');
    var html = '<div class="sun"></div>';
    [[14, -6, 220, 70], [30, 62, 160, 95], [8, 38, 110, 120], [46, 10, 130, 85]].forEach(function (c, i) {
      html += CLOUD.replace('class="cloud"', 'class="cloud" style="top:' + c[0] + '%;left:' + c[1] + '%;width:' + c[2] + 'px;animation-duration:' + c[3] + 's;animation-delay:-' + (i * 23) + 's;opacity:' + (.95 - i * .12) + '"');
    });
    [[14, 30], [84, 22], [72, 48], [24, 56]].forEach(function (s, i) {
      html += '<svg class="spark" style="left:' + s[0] + '%;top:' + s[1] + '%;animation-delay:-' + (i * .7) + 's" viewBox="0 0 24 24"><path d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12 7-1 11-5 12-12z"/></svg>';
    });
    html += '<div class="bubbles"></div>';
    d.innerHTML = html;
    h.insertBefore(d, h.firstChild);
    if (reduce) return;
    var box = d.querySelector('.bubbles'), count = window.innerWidth < 700 ? 3 : 7;
    var bubble = function (b, first) {
      var size = 24 + Math.random() * 50;
      b.className = 'bub';
      b.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (3 + Math.random() * 94) + '%;--t:' + (13 + Math.random() * 12) + 's;--dl:' + (first ? -Math.random() * 20 : 0) + 's;--sw:' + (Math.random() * 70 - 35) + 'px';
    };
    for (var i = 0; i < count; i++) {
      var b = document.createElement('span');
      bubble(b, true); box.appendChild(b);
      b.addEventListener('pointerdown', function (e) {
        var el = e.currentTarget;
        if (el.classList.contains('pop')) return;
        el.classList.add('pop'); burst(e.clientX, e.clientY, 8);
        setTimeout(function () { bubble(el, false); }, 380);
      });
    }
  });

  /* pause looping animations of blocks that are off screen */
  if (hasIO) {
    var po = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('off', !e.isIntersecting); });
    }, { rootMargin: '120px 0px' });
    [].forEach.call(document.querySelectorAll('[data-sky], .band.has-peek, .site-foot, .nf'), function (el) { po.observe(el); });
  }

  /* Tamitos hop when tapped, and the hero line up now and then on its own */
  var hop = function (el) {
    if (reduce) return;
    el.classList.remove('hop'); void el.offsetWidth; el.classList.add('hop');
    setTimeout(function () { el.classList.remove('hop'); }, 720);
  };
  [].forEach.call(document.querySelectorAll('.tami img, .peekers img, .peek, .helps img, [data-hop]'), function (im) {
    im.addEventListener('click', function (e) { hop(im); burst(e.clientX, e.clientY, 12); });
  });
  [].forEach.call(document.querySelectorAll('.tami'), function (t) {
    t.addEventListener('click', function () {
      [].forEach.call(document.querySelectorAll('.tami.on'), function (o) { if (o !== t) o.classList.remove('on'); });
      t.classList.toggle('on');
    });
  });
  var line = [].slice.call(document.querySelectorAll('.tami img'));
  if (!reduce && line.length) {
    setTimeout(function idle() {
      var vis = line.filter(function (t) { return t.offsetParent && !t.matches(':hover'); });
      if (vis.length && document.visibilityState === 'visible' && window.scrollY < window.innerHeight) hop(vis[Math.floor(Math.random() * vis.length)]);
      setTimeout(idle, 2600 + Math.random() * 2200);
    }, 3200);
  }

  /* collection sorting submits on change */
  [].forEach.call(document.querySelectorAll('[data-sort] select'), function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });

  /* product gallery */
  var gal = document.querySelector('[data-gallery]');
  if (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.addEventListener('click', function (e) {
      var b = e.target.closest('[data-src]');
      if (!b || !main) return;
      main.srcset = '';
      main.src = b.dataset.src;
      [].slice.call(gal.querySelectorAll('[data-src]')).forEach(function (x) {
        x.setAttribute('aria-selected', String(x === b));
      });
    });
  }

  /* quantity stepper */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v = Math.max(min, v + (b.dataset.qty === 'up' ? 1 : -1));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* cart: changing a quantity recalculates straight away */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.name || input.name.indexOf('updates[') !== 0) return;
    var f = input.form;
    if (!f) return;
    clearTimeout(f._t);
    f._t = setTimeout(function () { f.submit(); }, 450);
  });

  /* ----------------------------------------------------------------------
     Variant picker.

     Options are swatches and pills rather than a dropdown, so the shopper sees
     every colour and size at once. Choosing one keeps the hidden id, the price,
     the main photo, the add button and ?variant= in sync, and greys out the
     combinations the store cannot actually ship.
     ---------------------------------------------------------------------- */
  var form = document.querySelector('[data-variants]');
  if (form) {
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-variant-json]').textContent); } catch (err) {}

    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    var mainImg = document.querySelector('[data-gallery-main]');
    var satcPrice = document.querySelector('[data-satc-price]');
    var groups = [].slice.call(form.querySelectorAll('.opt-group'));

    var chosen = function () {
      return groups.map(function (g) {
        var f = g.querySelector('input[type="hidden"]');
        return f ? f.value : '';
      });
    };

    var match = function (sel) {
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return val === '' || v.options[i] === val; });
      })[0];
    };

    /* A value is offered only if some sellable variant still contains it, given
       everything already picked in the other groups. */
    var repaint = function () {
      var sel = chosen();
      groups.forEach(function (g, gi) {
        var btns = [].slice.call(g.querySelectorAll('.opt-sw,.opt-pill'));
        btns.forEach(function (b) {
          var probe = sel.slice();
          probe[gi] = b.dataset.value;
          var ok = variants.some(function (v) {
            return v.available && probe.every(function (val, i) { return val === '' || v.options[i] === val; });
          });
          b.disabled = !ok;
          b.classList.toggle('on', b.dataset.value === sel[gi]);
        });
        var cur = g.querySelector('[data-cur]');
        if (cur) { var selected = btns.filter(function (b) { return b.dataset.value === sel[gi]; })[0]; cur.textContent = selected ? (selected.dataset.label || sel[gi]) : ''; }
      });

      var v = match(sel);
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.innerHTML = (v.cheaper ? '<s>' + v.compare + '</s>' : '') + v.price;
      if (satcPrice) satcPrice.textContent = v.price;
      if (mainImg && v.img) mainImg.src = v.img;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.sold;
      }
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      } catch (e) {}
    };

    form.addEventListener('click', function (e) {
      var b = e.target.closest('.opt-sw,.opt-pill');
      if (!b || b.disabled) return;
      e.preventDefault();
      var g = b.closest('.opt-group');
      var f = g && g.querySelector('input[type="hidden"]');
      if (f) f.value = b.dataset.value;
      repaint();
    });

    repaint();

    /* sticky buy bar, shown once the real button leaves the screen */
    var bar = document.querySelector('[data-satc]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      bar.hidden = false;
      new IntersectionObserver(function (es) {
        var on = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        bar.classList.toggle('on', on);
        document.documentElement.classList.toggle('has-satc', on);
      }, { rootMargin: '0px' }).observe(addBtn);
      var sa = bar.querySelector('[data-satc-add]');
      if (sa) sa.addEventListener('click', function () { addBtn.click(); });
    }
  }

  /* ---------- top strip: rotate the promises on narrow screens ---------- */
  var strip = document.querySelector('[data-tstrip]');
  if (strip) {
    var its = [].slice.call(strip.querySelectorAll('.ts-item'));
    if (its.length > 1) {
      var n = 0;
      setInterval(function () {
        if (window.innerWidth > 720) return;
        its[n].classList.remove('on');
        n = (n + 1) % its.length;
        its[n].classList.add('on');
      }, 3200);
    }
  }

  /* ---------- copy the IBAN ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy-btn]');
    if (!b) return;
    var text = b.dataset.copy || '';
    var say = function () {
      var old = b.textContent;
      b.textContent = b.dataset.done || 'OK';
      setTimeout(function () { b.textContent = old; }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(say, function () {});
    else {
      var ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); say(); } catch (err) {}
      document.body.removeChild(ta);
    }
  });

  /* ---------- wishlist hearts (kept in this browser only) ---------- */
  var WKEY = 'tamitos_wish';
  var wish = [];
  try { wish = JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) {}
  document.querySelectorAll('[data-wish]').forEach(function (b) {
    if (wish.indexOf(b.dataset.wish) > -1) { b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.dataset.wish, i = wish.indexOf(h);
    if (i > -1) wish.splice(i, 1); else wish.push(h);
    b.classList.toggle('on', i === -1);
    b.setAttribute('aria-pressed', String(i === -1));
    try { localStorage.setItem(WKEY, JSON.stringify(wish)); } catch (err) {}
  });

  /* ----------------------------------------------------------------------
     10 % popup.

     Shown once per visitor, and never again after they sign up. "No thanks"
     snoozes it for a week rather than killing it, and the little tab in the
     corner stays as a way back in. All of it is per browser, so a visitor who
     clears their storage simply sees it again.
     ---------------------------------------------------------------------- */
  (function () {
    var ovl = document.getElementById('promoOvl');
    var tab = document.getElementById('promoTab');
    if (!ovl) return;

    var get = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
    var set = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
    var signedUp = function () { return get('tamitos_promo') === 'done'; };
    var snoozed = function () {
      var t = get('tamitos_promo_snooze');
      return t && Date.now() < parseInt(t, 10);
    };
    var seen = function () { try { return sessionStorage.getItem('tamitos_promo_seen') === '1'; } catch (e) { return true; } };

    var open = function () {
      ovl.hidden = false;
      requestAnimationFrame(function () { ovl.classList.add('open'); });
      document.documentElement.classList.add('promo-open');
      try { sessionStorage.setItem('tamitos_promo_seen', '1'); } catch (e) {}
      var f = ovl.querySelector('input[type="email"]');
      if (f && window.innerWidth > 700) setTimeout(function () { f.focus(); }, 380);
    };
    var close = function (snooze) {
      ovl.classList.remove('open');
      document.documentElement.classList.remove('promo-open');
      setTimeout(function () { ovl.hidden = true; }, 320);
      if (snooze) set('tamitos_promo_snooze', String(Date.now() + 7 * 24 * 3600 * 1000));
      if (tab && !signedUp()) tab.classList.add('show');
    };

    var x = document.getElementById('promoX');
    var no = document.getElementById('promoNo');
    if (x) x.addEventListener('click', function () { close(true); });
    if (no) no.addEventListener('click', function () { close(true); });
    ovl.addEventListener('click', function (e) { if (e.target === ovl) close(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ovl.classList.contains('open')) close(true);
    });
    var done = ovl.querySelector('[data-promo-done]');
    if (done) done.addEventListener('click', function () { set('tamitos_promo', 'done'); });
    if (tab) tab.addEventListener('click', open);

    if (signedUp()) return;
    if (snoozed() || seen()) { if (tab) tab.classList.add('show'); return; }
    setTimeout(open, 6000);
  })();
})();
